import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsString } from "class-validator";

export class UserCashbox {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  currency!: string;
  @Expose()
  @IsBoolean()
  isAssign!: boolean;
  @Expose()
  @IsBoolean()
  isDefault!: boolean;
}
